// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function formatFloat(f) {
  if (f % 1.0 === 0.0) {
    return (f | 0).toString();
  } else {
    return f.toString();
  }
}

function clampFloat(minimum, maximum, value) {
  return Math.min(maximum, Math.max(minimum, value));
}

exports.formatFloat = formatFloat;
exports.clampFloat = clampFloat;
/* No side effect */
